import { Outlet } from 'react-router-dom';
import { AuthInitializer } from '../components/Auth';
import { StoreContext } from '..';
import { store } from '../store';

import '@assets/scss/home.scss';
import '@assets/scss/index.scss';

export const MainLayout = () => {
  return (
    <StoreContext.Provider value={store}>
      <AuthInitializer>
        <Outlet />
      </AuthInitializer>
    </StoreContext.Provider>
  );
};
